module.exports = __webpack_public_path__ + "fonts/SegmentLight.woff2";